import { Component, OnInit } from '@angular/core';
import { AuthService } from './shared/services/auth.service';
import { environment } from '../environments/environment';
import { UserAccessModel } from './shared/models/user-access.model';
import { getRouteKeyMatchByUrlNSS, getRouteKeyMatchByUrlOldSS, getRouteKeyMatchByUrlShipmentPortal } from './shared/helper/helper';
import { PermissionModel } from './shared/models/permission.model';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { MaterialModule } from './shared/material.module';
import { CommonModule } from '@angular/common';
import { TopNavComponent } from './core/top-nav/top-nav.component';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { FooterComponent } from './core/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    RouterOutlet,
    RouterModule,
    TopNavComponent,
    LoadingComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  title = 'SuiteEdge3.x';
  isAuth: boolean;
  user: UserAccessModel | null;
  isLoading = false;

  private pwdRegexp: RegExp = /The\+user\+has\+forgotten\+their\+password/gi;
  private pwdCancelRegexp: RegExp = /The\+user\+has\+cancelled\+entering\+self-asserted/gi;

  private static loadSisenseJsScript(): void {
    const node = document.createElement('script');
    node.src = environment.externalUrls.sisenseJs;
    node.type = 'text/javascript';
    node.async = false;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.redirectForgotPassword();
    this.setTheme();

    this.authService.implicitFlow();
    this.authService.isAuthenticated.subscribe(authStatus => {
      this.isAuth = authStatus;
      if (authStatus) {
        this.authService.getUserAccess().subscribe({
          next: userInfo => {
            this.isLoading = false;
            this.authService.userInfo.next(userInfo);
          },
          error: () => {
            setTimeout(() => this.authService.logOut(), 2500);
            this.isLoading = false;
          }
        });
        AppComponent.loadSisenseJsScript();
      }
    });

    this.authService.userInfo.subscribe(userInfo => {
      this.user = userInfo;
      if (userInfo) {
        if (!this.hasUrlAccess) {
          this.router.navigate(['/']);
        }
        this.loadChatIdentity(`${userInfo.firstName} ${userInfo.lastName}`);
      }
    });
  }

  private setTheme(): void {
    const isLightTheme = localStorage.getItem('lightTheme');

    if (isLightTheme && isLightTheme === 'true') {
      this.authService.switchMode(true);
    } else if (isLightTheme && isLightTheme === 'false'){
      this.authService.switchMode(false);
    } else {
      this.authService.switchMode(true);
    }
  }

  private redirectForgotPassword(): void {
    const url = window.location.href;
    if (url.search(this.pwdRegexp) !== -1) {
      window.open(environment.oidc.pwdResetURL, '_self');
    } else if (url.search(this.pwdCancelRegexp) !== -1) {
      window.open(environment.oidc.allowedURLs[1], '_self');
    }
  }

  private compareUrlKey( key: string, permsList: PermissionModel[] | null | undefined = this.user?.permissions ): PermissionModel | null {
    let result = null;
    permsList?.find(perm =>
      result = perm.viewKey === key ? perm : this.compareUrlKey( key, perm.children ));

    return result;
  }

  loadChatIdentity(name: string): void {
    const w: any = window;
    w.FrontChat('init', {
      chatId: 'cc57ecc7f4cf5da1f148ee9a023f9dc7',
      useDefaultLauncher: true,
      name
    });
  }

  get hasUrlAccess(): boolean {
    const urlTriggered = window.location.pathname;
    const keysNSS = getRouteKeyMatchByUrlNSS(urlTriggered);
    const keysOldSS = getRouteKeyMatchByUrlOldSS(urlTriggered);
    const keysShipmentPortal = getRouteKeyMatchByUrlShipmentPortal(urlTriggered);
    const key = keysNSS || keysOldSS || keysShipmentPortal;

    if (key) {
      const existInNavigation = this.compareUrlKey( key );
      return !!existInNavigation;
    } else {
      return true;
    }

  }
}
